import { useEffect } from 'react';

export const useBrowserPinchToZoom = () => {
  useEffect(() => {
    const preventZoom = event => {
      if ('scale' in event && event.scale !== 1) {
        event.preventDefault();
      }
    };

    // Add touchmove listener
    document.addEventListener('gesturestart', preventZoom);
    document.addEventListener('gesturechange', preventZoom);
    document.addEventListener('touchmove', preventZoom, { passive: false });

    return () => {
      // Cleanup: Remove listener and style tag
      document.removeEventListener('gesturestart', preventZoom);
      document.removeEventListener('gesturechange', preventZoom);
      document.removeEventListener('touchmove', preventZoom);
    };
  }, []);
};
